import { anonGroupIdVar, otpVar } from '../graphql/stores/local'

export const authorizedHeader = () => {
  const authToken = localStorage.getItem('authToken')

  return {
    ...getHeader(),
    authorization: `Bearer ${authToken}`,
  }
}

export const getHeader = function () {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
}

export const buildHeaders = headers => {
  const token = localStorage.getItem('token')
  const user = JSON.parse(localStorage.getItem('authenticatedUser'))
  const participantId = localStorage.getItem('participantId')
  const subdomain = localStorage.getItem('subdomain')
  const otp = localStorage.getItem('otp') || otpVar()
  const anonGroupId = localStorage.getItem('anonGroupId') || anonGroupIdVar()

  return {
    ...headers,
    authorization: token ? `Bearer ${token}` : '',
    'x-auth-sd': subdomain,
    'x-auth-sub': user ? user.sub : undefined,
    'x-auth-participant-id': participantId ? participantId : undefined,
    'x-auth-otp': otp,
    'x-auth-group-id': anonGroupId,
  }
}

export const getFullAuthorizationHeader = buildHeaders
